import { render, staticRenderFns } from "./TiptapMenuBar.vue?vue&type=template&id=1beb3070&scoped=true"
import script from "./TiptapMenuBar.vue?vue&type=script&lang=js"
export * from "./TiptapMenuBar.vue?vue&type=script&lang=js"
import style0 from "./TiptapMenuBar.vue?vue&type=style&index=0&id=1beb3070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb3070",
  null
  
)

export default component.exports